// extracted by mini-css-extract-plugin
export default {"app":"DataTableCard_app__zI5EF","search":"DataTableCard_search__nPP-C"};